import { ButtonBase, ListItem, Menu, Typography } from '@material-ui/core'
import React, { useState } from 'react'

import { ImportDataMpdal } from '../../components/ImportDataMpdal'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { Accommodation } from '../../types/accommodation'
import useStyles from './styles/AccommodationRowMobile.styles'

interface UserRowMobileProps {
  hasAccessToViewRoomType: boolean | undefined
  hasAccessToViewRatePlan: boolean | undefined
  data: Accommodation
  RoleAccessToViewAccommodationDeatils: boolean | undefined
  RoleAccessToViewImportData: boolean | undefined
}

const UserRowMobile: React.FC<UserRowMobileProps> = ({
  data,
  hasAccessToViewRoomType,
  hasAccessToViewRatePlan,
  RoleAccessToViewAccommodationDeatils,
  RoleAccessToViewImportData
}) => {
  const {
    basicDetails: { name, propertyCode, accommodationID }
  } = data
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false)

  const handleOpenMenu = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (isOpenModal) {
      return
    } // prevent menu from opening when modal is open
    setIsOpen(!isOpen)
    setAnchorEl(e.currentTarget)
  }

  return (
    <ButtonBase
      className={[
        classes.tableRow,
        !RoleAccessToViewAccommodationDeatils ? classes.cursorDefault : ''
      ].join(' ')}
      onClick={handleOpenMenu}>
      <div className={classes.nameCell}>
        <Typography variant="h4">{name}</Typography>
      </div>
      <div>
        <Typography variant="body1">{propertyCode}</Typography>
      </div>
      <Menu open={isOpen} anchorEl={anchorEl}>
        <ListItem
          disabled={!RoleAccessToViewAccommodationDeatils}
          button
          component={LocalizedLink}
          to={`/accommodations/${accommodationID}/${propertyCode}/details`}>
          {getTranslate('View Accommodation details')}
        </ListItem>
        <ListItem
          disabled={!hasAccessToViewRoomType}
          button
          component={LocalizedLink}
          to={`/accommodations/${accommodationID}/room-types/list`}>
          {getTranslate('View Room Types')}
        </ListItem>
        <ListItem
          disabled={!hasAccessToViewRatePlan}
          button
          component={LocalizedLink}
          to={`/accommodations/${accommodationID}/rate-plans/list`}>
          {getTranslate('View Rate Plans')}
        </ListItem>
        {RoleAccessToViewImportData && (
          <ListItem
            disabled={!RoleAccessToViewImportData}
            button
            onClick={() => {
              setIsOpen(false)
              setIsOpenModal(true)
            }}>
            {getTranslate('Import Data')}
          </ListItem>
        )}
      </Menu>
      {isOpenModal && (
        <ImportDataMpdal
          propertyCode={propertyCode}
          isOpen={isOpenModal}
          onClose={() => setIsOpenModal(false)}
        />
      )}
    </ButtonBase>
  )
}

export default UserRowMobile
